import AlertsService from './alerts.service';
import AuthenticationService from './authentication.service';
import BuyersService from './buyers.service';
import CategoryService from './categories.service';
import ContactsService from './contacts.service';
import ContractsService from './contracts.service';
import ComplianceService from './compliance.service';
import CpaService from './cpa.service';
import CrossReferencesService from './crossReferences.service';
import EnhancedAnalyticsService from './enhancedAnalytics.service';
import EventNotificationService from './eventNotification.service';
import FeaturesService from './features.service';
import FilesService from './files.service';
import HistoryService from './history.service';
import OffersService from './offers.service';
import OrganizationGroupsService from './organizationGroups.service';
import OrganizationsService from './organizations.service';
import PermissionsService from './permissions.service';
import ProductsService from './products.service';
import PurchasePlansService from './purchasePlans.service';
import RebatesService from './api.rebates';
import RfpService from './rfps/rfp.service';
import TransactionStatusesService from './transactionStatuses.service';
import SellersService from './sellers.service';
import UserAccountService from './userAccount.service';
import UsersService from './users.service';

export interface IApiService {
  alerts: AlertsService;
  authentication: AuthenticationService;
  buyers: BuyersService;
  categories: CategoryService;
  contacts: ContactsService;
  contracts: ContractsService;
  compliance: ComplianceService;
  cpas: CpaService;
  crossReferences: CrossReferencesService;
  enhancedAnalytics: EnhancedAnalyticsService;
  eventNotification: EventNotificationService;
  features: FeaturesService;
  files: FilesService;
  history: HistoryService;
  offers: OffersService;
  organizationGroups: OrganizationGroupsService;
  organizations: OrganizationsService;
  permissions: PermissionsService;
  products: ProductsService;
  purchasePlans: PurchasePlansService;
  rebates: RebatesService;
  rfps: RfpService;
  transactionStatuses: TransactionStatusesService;
  sellers: SellersService;
  useraccount: UserAccountService;
  users: UsersService;
}

export default function ApiService($http, $q) {
  'ngInject';

  let api = {
    alerts: new AlertsService($http),
    authentication: new AuthenticationService($http),
    buyers: new BuyersService($http),
    categories: new CategoryService($http, $q),
    contacts: new ContactsService($http),
    compliance: new ComplianceService($http),
    contracts: new ContractsService($http),
    cpas: new CpaService($http),
    crossReferences: new CrossReferencesService($http),
    enhancedAnalytics: new EnhancedAnalyticsService($http),
    eventNotification: new EventNotificationService($http),
    features: new FeaturesService($http),
    files: new FilesService($http),
    history: new HistoryService($http),
    offers: new OffersService($http),
    organizationGroups: new OrganizationGroupsService($http),
    organizations: new OrganizationsService($http),
    permissions: new PermissionsService($http),
    products: new ProductsService($http, $q),
    purchasePlans: new PurchasePlansService($http, $q),
    rebates: new RebatesService($http),
    rfps: new RfpService($http),
    transactionStatuses: new TransactionStatusesService($http),
    sellers: new SellersService($http),
    useraccount: new UserAccountService($http),
    users: new UsersService($http)
  };

  return api;
}
